(function () {
  var panel = document.querySelector('[data-sk-panel]');
  var form = document.getElementById('sk-ff');
  if (!panel || !form) { return; }
  var ov = document.querySelector('[data-sk-ov]');
  var desk = window.matchMedia('(min-width: 1025px)');
  var applyBtn = panel.querySelector('.sk-ff__foot .sk-btn');
  var last = null, timer = null, countTimer = null, token = 0;
  function submit() { if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); } }
  function open() {
    last = document.activeElement;
    panel.classList.add('is-open'); if (ov) { ov.classList.add('is-open'); }
    document.documentElement.style.overflow = 'hidden';
    var f = panel.querySelector('.sk-ff__x'); if (f) { setTimeout(function () { f.focus(); }, 60); }
  }
  function close() {
    panel.classList.remove('is-open'); if (ov) { ov.classList.remove('is-open'); }
    document.documentElement.style.overflow = '';
    if (last && last.focus) { last.focus(); }
  }
  /* live "Show N results" on phones: ask the server how many products match the chosen filters */
  function refreshCount() {
    if (!applyBtn || desk.matches) { return; }
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '') { params.append(k, v); } });
    var mine = ++token;
    applyBtn.textContent = 'Updating…';
    fetch(form.action + '?' + params.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (mine !== token) { return; }
        var m = html.match(/class="sk-tb__count"[^>]*>\s*([\d,]+)/);
        var n = m ? parseInt(m[1].replace(/,/g, ''), 10) : null;
        if (n === null) { applyBtn.textContent = 'Show results'; applyBtn.disabled = false; return; }
        applyBtn.disabled = (n === 0);
        applyBtn.textContent = n === 0 ? 'No results' : 'Show ' + n + ' ' + (n === 1 ? 'result' : 'results');
      })
      .catch(function () { if (mine === token) { applyBtn.textContent = 'Show results'; applyBtn.disabled = false; } });
  }
  document.querySelectorAll('[data-sk-open]').forEach(function (b) { b.addEventListener('click', open); });
  document.querySelectorAll('[data-sk-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.querySelectorAll('[data-sk-more]').forEach(function (b) {
    b.addEventListener('click', function () {
      var ul = b.previousElementSibling;
      var on = ul.classList.toggle('is-expanded');
      b.textContent = on ? 'Show fewer' : 'Show all ' + ul.children.length;
    });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) { close(); } });
  form.addEventListener('change', function () {
    if (desk.matches) { clearTimeout(timer); timer = setTimeout(submit, 350); }
    else { clearTimeout(countTimer); countTimer = setTimeout(refreshCount, 250); }
  });
  form.addEventListener('submit', function () {
    form.querySelectorAll('input[type=number]').forEach(function (i) { if (!i.value) { i.disabled = true; } });
  });
  var sort = document.querySelector('[data-sk-sort]');
  if (sort) { sort.addEventListener('change', submit); }
  if (desk.addEventListener) { desk.addEventListener('change', function () { if (desk.matches) { close(); } }); }

  /* phones: pin the Filter / Sort bar to the top once it has scrolled out of view
     (the theme's page wrapper clips overflow, so CSS position:sticky cannot be used) */
  var tb = document.querySelector('.sk-tb');
  if (tb) {
    var ph = document.createElement('div');
    tb.parentNode.insertBefore(ph, tb);
    var stuck = false;
    var unstick = function () { if (stuck) { tb.classList.remove('is-stuck'); ph.style.height = ''; stuck = false; } };
    var onScroll = function () {
      if (desk.matches) { unstick(); return; }
      var top = ph.getBoundingClientRect().top;
      if (!stuck && top <= 0) { ph.style.height = tb.offsetHeight + 'px'; tb.classList.add('is-stuck'); stuck = true; }
      else if (stuck && top > 0) { unstick(); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }
})();